import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";

@Component({
    selector: 'app-component-error-e400',
    templateUrl: './error-e400.component.html',
    styleUrls: ['./error-e400.component.css']
})

export class ErrorE400Component implements OnInit {
    isMobile = window.innerWidth < 1000 ? true : false;

    constructor(private router : Router, private titleService : Title) { 
        this.titleService.setTitle("Lỗi 400 - Bad Request");
    }

    ngOnInit() {}

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }
}